'use client';
import styled from 'styled-components';

export const Bg = styled.div`
  background: ${props => props.theme.colors.neutral.bone};
  padding: ${({ theme }) => theme.spacing(16, 4)};
  width: 100%;

  @media ${({ theme }) => theme.tablet} {
    padding: ${({ theme }) => theme.spacing(16, 0)};
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 750px;
  margin: 0 auto;
  text-align: center;
`;

export const FeatureContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin: ${({ theme }) => theme.spacing(6, 0, 8, 0)};

  @media ${({ theme }) => theme.tablet} {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }
`;

export const Headline = styled.h2`
  ${({ theme }) => theme.typography.subheading1}
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Text = styled.p`
  ${({ theme }) => theme.typography.heading2}
`;
